import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  või al. <span style="color:#a6d189;">**{tax}**</span> kuus

  <span style="color:#85c1dc;">**FI:**</span>
  tai alkaen <span style="color:#a6d189;">**{tax}**</span> /kk

  <span style="color:#85c1dc;">**RU:**</span>
  или от <span style="color:#a6d189;">**{tax}**</span> в месяц
*/
/* @__NO_SIDE_EFFECTS__ */
const m1602 = msg(
  mf`või al. ${'tax'} kuus`,
  mf`tai alkaen ${'tax'} /kk`,
  mf`или от ${'tax'} в месяц`,
)

export { m1602 as 'w.module.product.monthly_pay' }